export default "__VITE_ASSET__B_FH0Oiw__"